module.exports = __webpack_public_path__ + "9c40ec0c266f86dbd5991b38f4fb454b.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/MQ.svg
// module id = XNER
// module chunks = 0